import { z } from "zod";
import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@shared/services/api/apiRequest";
import { makeFormFields } from "@shared/utils/makeFormFields";
import { FieldType } from "@shared/features/form/Form";
import {
  contactSchemaBaseFields,
  withEmailConfirmationValidation,
} from "@shared/schemas/sharedSchemas";
import { FormDialog } from "@shared/features/form/FormDialog";
import { marketingEventBus } from "../../marketing.events";

export function AddYourInstitutionDialog() {
  const schema = withEmailConfirmationValidation(
    z.object({
      ...contactSchemaBaseFields,
      organization: z.string().min(1, "Organization is required"),
    })
  );

  const fields = makeFormFields([
    "firstName",
    "lastName",
    "email",
    "confirmEmail",
    "organization",
    "message",
  ]);

  const submitForm = useMutation({
    mutationFn: async (data: z.infer<typeof schema>) => {
      try {
        marketingEventBus.emitEvent("addInstitution:submit", data);

        return await apiRequest("/api/form-submission-proxy/", "POST", {
          first_name: data.firstName,
          last_name: data.lastName,
          ...data,
          form_type: "institution",
        });
      } catch (error) {
        throw error;
      }
    },
    onSuccess: (data, variables) => {
      marketingEventBus.emitEvent("addInstitution:success", variables);
    },
  });

  return (
    <FormDialog
      dialogName="addYourInstitution"
      title="Add your Alumni"
      description="Fill out the form below to get in touch about becoming a Sending Institution for Pollinator's next session."
      successTitle="Success!"
      successDescription="Thank you for your interest in becoming a Sending Institution. We'll be in touch soon."
      schema={schema}
      fields={fields as FieldType[]}
      onSubmit={submitForm.mutateAsync}
    />
  );
}

export default AddYourInstitutionDialog;
